"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var DOCUMENT_TYPES = _interopRequireWildcard(require("./types"));

var _DOCUMENT_TYPES_LABEL;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DOCUMENT_TYPES_LABELS = (_DOCUMENT_TYPES_LABEL = {}, _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ADDITION, 'Additional'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ADD_EMPLOYMENT_BUSINESS, 'Additional Employment/Business'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.AMENDMENT, 'Amendment'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CERTIFICATE_OF_COMPLETION, 'Certificate of Completion'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CERTIFICATE_OF_COUNSELING, 'Certificate of Counseling'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CREDITOR_MATRIX, 'Creditor Matrix'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.CREDIT_REPORT, 'Credit Report'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.ESIGN, 'E-Sign'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.FORM_101_A, 'Eviction Judgment'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.FORM_103, 'Fee Waiver'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.JUDGMENT, 'Judgments'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.LOCAL_FORMS, 'District Forms'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.MEDICAL_RECORD, 'Medical Bills'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PACKET_FILING, 'Filing Packet'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PACKET_TRUSTEE, 'Trustee Packet'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_ADVICES, 'Pay Stubs'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_DAY_LOAN, 'Pay Day Loans'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PAY_STUB, 'Pay Stub'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.PETITION, 'Docassemble Petition'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.SUPPORT_DOCUMENTS, 'Support Documents'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.TAX_RETURN, 'Tax Returns'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.TAX_RETURN_REQUEST, '4506-T Request Form'), _defineProperty(_DOCUMENT_TYPES_LABEL, DOCUMENT_TYPES.UTILITY, 'Utilities'), _DOCUMENT_TYPES_LABEL);
var _default = DOCUMENT_TYPES_LABELS;
exports["default"] = _default;